import React from "react";
import { MapPin, Clock, Wrench, ShieldCheck, CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const services = [{
  title: "ליווי סיעודי צמוד",
  description: "השגחה וסיוע מלא בפעולות היום-יום על ידי מטפלים מוסמכים ומנוסים.",
  icon: <ShieldCheck className="size-5 text-primary" />
}, {
  title: "סיוע לאחר אשפוז",
  description: "תמיכה מקצועית בתהליך ההחלמה בבית, כולל מעקב תרופתי וסיוע פיזי.",
  icon: <Wrench className="size-5 text-primary" />
}, {
  title: "התאמת מטפל אישי",
  description: "התאמה מדויקת של המטפל לצרכי המטופל, תוך דגש על שפה וחיבור אישי.",
  icon: <CircleCheck className="size-5 text-primary" />
}];
const serviceAreas = [{
  name: "תל אביב",
  path: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
}, {
  name: "רמת גן",
  path: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  name: "חיפה",
  path: "/NursingCareProviderInHaifaWithinHoursPage"
}, {
  name: "ירושלים",
  path: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  name: "פתח תקווה",
  path: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  name: "הרצליה",
  path: "/NursingCareProviderInHerzliyaWithinFiveHoursPage"
}];
export default function LocalServicesInCandiac() {
  return <section data-section-id="252554" id="שירותים-סיעודיים" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="bg-accent text-accent-foreground font-default">
                <MapPin className="size-3.5 ml-1" />
                שירות סיעודי בפריסה ארצית
              </Badge>
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
                מומחים במתן פתרונות סיעוד וטיפול בבית
              </h2>
              <p className="text-muted-foreground text-lg font-default max-w-xl">
                אנו מספקים מענה מיידי ומקצועי לכל צורך סיעודי, עם דגש על יחס אישי, ביטחון ואיכות חיים למטופל ולמשפחתו.
              </p>
            </div>

            <div className="grid gap-6 mt-4">
              {services.map((service, i) => <div data-index={i} key={i} className="flex gap-4 items-start">
                  <div className="bg-accent p-3 rounded-lg shrink-0">
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="font-default text-xl font-semibold text-foreground mb-1">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground font-default">
                      {service.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="pt-4">
              <Button size="lg" className="w-full sm:w-auto font-default text-base bg-primary text-primary-foreground hover:opacity-90 transition-opacity rounded-md shadow-md">
                 תיאום פגישת ייעוץ ללא עלות
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="relative rounded-lg overflow-hidden shadow-lg aspect-[4/3] w-full">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_home_service.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_home_service.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_home_service.png-wvc-sizes" alt="שירותי סיעוד מקצועיים בבית" className="object-cover w-full h-full" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 to-transparent flex items-end p-6">
                <p className="text-secondary-foreground font-default font-semibold text-xl">
                  זמינות מיידית בבית המטופל
                </p>
              </div>
            </div>

            <Card className="border-border shadow-md rounded-lg bg-card">
              <CardHeader className="pb-4">
                <CardTitle className="font-default text-2xl text-foreground flex items-center gap-2">
                  <Clock className="size-6 text-primary" />
                  זמני תגובה ומענה
                </CardTitle>
                <CardDescription className="font-default text-base text-muted-foreground">
                  אנחנו כאן בשבילכם ברגעים הקריטיים ביותר.
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-center justify-between bg-muted/30 p-4 rounded-md">
                  <span className="font-default font-medium text-foreground">ייעוץ טלפוני ראשוני</span>
                  <Badge variant="default" className="font-default bg-primary text-primary-foreground">מיידי</Badge>
                </div>
                <div className="flex items-center justify-between bg-muted/30 p-4 rounded-md">
                  <span className="font-default font-medium text-foreground">הגעת מטפל לבית</span>
                  <Badge variant="outline" className="font-default border-primary text-primary">עד 5 שעות</Badge>
                </div>

                <Separator className="my-4 bg-border" />

                <div>
                  <h4 className="font-default text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
                    <MapPin className="size-5 text-muted-foreground" />
                    ערים מרכזיות בשירות
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {serviceAreas.map((area, i) => <Link data-index={i} key={i} to={area.path}>
                        <Badge variant="secondary" className="hover:bg-primary hover:text-primary-foreground transition-colors cursor-pointer font-default py-1.5 px-3 rounded-md">
                          {area.name}
                        </Badge>
                      </Link>)}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}